/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:numberValidator
 * @restrict A
 * @param    {string=} numberValidator  Error popup title.
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} disableValidator "true"=skip validation.
 * @param    {string=} minValue         Minimum value.
 * @param    {string=} maxValue         Maximum value.
 *
 * @description
 * Validator to verify a number input value within a range.
 **/
/* @ngInject */
export function numberValidator(CSMValidatorService, Tools) {
  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      return (
        CSMValidatorService.BaseValidator.prototype.doValidate.call(
          this,
          value
        ) ||
        (function ($val) {
          /*---------------------------------------*/
          /* If input is empty, it was't required. */
          /*---------------------------------------*/
          if (Tools.isEmpty(value)) return null;

          var numValue = Number(String(value).replace(/,/g, ''));

          if (isNaN(numValue)) return 'Must be a Number';

          var minValue = ($val.attributes.minValue || '').parseNumber();
          if (!isNaN(minValue) && numValue < minValue)
            return 'Must be {0} or more'.format(minValue);

          var maxValue = ($val.attributes.maxValue || '').parseNumber();
          if (!isNaN(maxValue) && numValue > maxValue)
            return 'Must be {0} or less'.format(maxValue);
        })(this)
      );
    }
  });
}
